<template>
<div class="no-padding block-assets-wrapper">
      <info-box-header v-if="!isFeed" :title="'Program Block Assets'" :expanded="expanded" @toggleShow="expanded = !expanded"></info-box-header>

      <div class="block-assets-content" :class="{hide: !expanded}">
         <div id="slots_table">

            <div v-if="!hideAddSlot" class="controls-wrapper">
               <div id="add_slot_btn">
                  <button class="add-slot" @click="$emit('addSlotClicked')">
                     Add Slot
                  </button>
               </div>
            </div>

            <div v-if="isLoadingSlots">
               <div class="loader-wrapper">
                  <div class="loader">
                  </div>
               </div>
            </div>

            <div v-else class="block-slots-wrapper">

               <slot name="slotlist">
               </slot>
                  
            </div>

         </div>
      </div>

      <!-- Edit Smart Canvas Modal -->
      <!-- <smart-canvas-overlay
         v-if="editInstModal"
         :instanceAssetRecid="editInstRecid"
         @closeOverlay="closeModal">
      </smart-canvas-overlay> -->

      <!-- Media Picker -->
      <transition name="slideleft">
         <media-picker 
            v-if="mediaPickerOpen && !isEditingInstance"
            :channels="[channelRecid]"
            :channelRecid="channelRecid"
            :assetType="mpAssetTypes"
            :isScoreboard="isScoreboard"
            :multiSelect="true"
            :activeId="-1"
            :activeAssetId="currSelectedAsset"
         ></media-picker>
      </transition>

   </div>

</template>

<script>
import MediaPicker from '@/global/media_picker/MediaPicker';

export default {
   components: {
      MediaPicker
   },

   props: {
      mediaPickerOpen: {
         type: Boolean,
         required: true
      },
      isEditingInstance: {
         type:Boolean,
         required: false,
         default: false
      },
      channelRecid: {
         type: Number | String,
         required: false,
         default: ''
      },
      // isDragging: {
      //    type: Boolean,
      //    required: true,
      // },
      // assetIsOver: {
      //    type: Boolean,
      //    required: true
      // },
      isLoadingSlots: {
         type: Boolean,
         required: true
      },
      isFeed: {
         type: Boolean,
         required: false,
         default: false
      },
      mpAssetTypes: {
         type: Array,
         required: true
      },
      isScoreboard: {
         type: Boolean,
         required: false,
         default: false
      },
      hideAddSlot: {
         types: Boolean,
         required: false,
         default: false
      },
      currSelectedAsset: {
         types: Number | String,
         required: false,
         default: -1
      }
   },

   data() {
      return {
         expanded: true,
      }
   },
}
</script>

<style lang="scss" scoped>
.block-assets-wrapper {
   margin-right: 15px;
   width: 75%;

   &.feed {
      margin: 0 auto;
      width: 100%;
   }

   &.mp {
      width: 90%;
   }
}

.block-assets-content {
   padding: 20px 0;

   &.hide {
      display: none;
   }
}

#add_slot_btn {
   display: flex;
   align-items: center;
}

.add-slot-btn {
   padding-left: 12px;
   width: 120px;
}

span.add-slot {
   font-size: 12px;
   text-transform: uppercase;
   color: #b2b2b2;
   vertical-align: text-top;
}

.block-slots-wrapper {
   box-sizing: border-box;
}

.controls-wrapper {
   color: #a4a4a4;

   button {
      position: relative;
      padding-left: 30px;
      border: 0; 
      background-color: transparent;
      color: inherit;
      transition: background-image 0.25s ease; 
      text-transform: uppercase;
      font-size: 12px;
      transition: background-image all 0.25s ease; 

      &:hover {
         color: white;
      }
   }

   > div {
      display: inline-block;
   }

   #add_slot_btn {
      button {
         background: url('../../assets/img/instances/SVGs/bttn_add.svg') no-repeat left center transparent;
         background-size: 20px 20px;

         &:hover {
            background-image: url('../../assets/img/instances/SVGs/bttn_add-active.svg'); 
         }
      }
   }

   // #open_mp_btn {
   //    float: right;

   //    button {
   //       background: url('../../../../assets/img/toolbox/ft-media-picker-off.svg') no-repeat left center transparent;
   //       background-size: 20px 20x;
   //       &:hover {
   //          background-image: url('./../../../../assets/img/toolbox/ft-media-picker-on.svg');
   //       }
   //    }
   // }
}

#slots_list {
   width: 100%;
   margin-top: 1em;
   margin-bottom: 1em;
   font-size: .85em;

   width: calc(100% + 18px) !important; //hides the default scroll

   .table-row {
      padding-right: 25px;

      &.top {
         border-bottom: 1px solid #354658;
      }
   }

   
}

.row-wrapper {
   .rows {
      max-height: 500px;
      padding-right: 25px;
      width: 100% !important;
      
   }
}

.rows::-webkit-scrollbar {
  display: none;
}

.table-row {
   display: flex;
   justify-content: space-between;

   // &:first-child {
   //    border-bottom: 1px solid #313d4f;
   // }

   .header {
      font-size: 13px;
      font-weight: normal;
      color: #7f8fa4;
      text-align: left;

      padding-bottom: 10px;
   }

   .order {
      width: 6%;
      padding: 0 10px;
   } 

   .asset {
      width: 30%;
   }

   .duration {
      width: 9%;
   }

   .asset-type {
      width: 9%;
      text-align: center;
   }

   .file-type {
      width: 8%;
      text-align: center;
   } 

   .status {
      width: 10%;
      text-align: center;
   }

   // .check {
   //    // width: 53px;
   //    width: 65px;
   //    text-align: center;
   // }

   // .loop {
   //    order: 6;
   // }

   // .hot-pick {
   //    order: 7;
   // }

   // .no-ads {
   //    order: 8;
   // }

   .buttons {
      width: 18%;
   }
}

.drop-box {
   width: 100%;
   border: 1px solid white;
   height: 250px;
   text-align: center;

   &.is_dragging {
      border: 1px solid $bard-gold;
      background: #161a23;
   }
}

</style>


